// src/date/util.ts
var parseDateString = (dateString) => {
  if (typeof dateString !== "string") return "";
  let safeDate = dateString.replace(" ", "T").replace(/\//g, "-");
  const date = safeDate == null ? void 0 : safeDate.split("T")[0];
  const [day, month, year] = (date == null ? void 0 : date.split("-")) || "";
  if (day.length <= 2) {
    safeDate = `${year}-${month}-${day}`;
  }
  return safeDate;
};
var parseDate = (date, options) => {
  let safeDate = (date == null ? void 0 : date.replace(" ", "T")) || Date.now();
  if (typeof safeDate === "string") {
    safeDate = parseDateString(safeDate);
  }
  try {
    const parts = splitDateTime(safeDate, "en", {
      ...options,
      hour12: false,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    });
    const dateObj = /* @__PURE__ */ new Date(`${parts.date}T${parts.time}`);
    return dateObj;
  } catch (error) {
    return /* @__PURE__ */ new Date();
  }
};
var splitDateTime = (date, locale, options) => {
  let safeDate = typeof date === "string" ? date == null ? void 0 : date.replace(" ", "T") : date || Date.now();
  if (typeof safeDate === "string") {
    safeDate = parseDateString(safeDate);
  }
  const isUTC = typeof date === "string" && date.length <= 10;
  const defaultoptions = {
    numberingSystem: "latn",
    timeZone: isUTC ? "UTC" : "Asia/Riyadh",
    hourCycle: "h24",
    hour12: true,
    year: "numeric",
    month: "long",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit"
  };
  const parts = new Intl.DateTimeFormat(locale, {
    ...defaultoptions,
    ...options
  }).formatToParts(new Date(safeDate));
  let year = "";
  let month = "";
  let day = "";
  let hour = "";
  let minute = "";
  let second = "";
  let dayPeriod = "";
  let weekday = "";
  for (const part of parts) {
    switch (part.type) {
      case "year":
        year = part.value;
        break;
      case "month":
        month = part.value;
        break;
      case "day":
        day = part.value;
        break;
      case "hour":
        hour = part.value;
        break;
      case "minute":
        minute = part.value;
        break;
      case "second":
        second = part.value;
        break;
      case "dayPeriod":
        dayPeriod = part.value;
        break;
      case "weekday":
        weekday = part.value;
        break;
      default:
        break;
    }
  }
  const time = `${hour}:${minute}${dayPeriod ? " " + dayPeriod : ""}`;
  return { year, month, day, weekday, date: `${year}-${month}-${day}`, hour, minute, second, time };
};

export {
  parseDateString,
  parseDate,
  splitDateTime
};
//# sourceMappingURL=chunk-C3UEOT3Y.mjs.map